import { useCallback, useContext, useEffect, useMemo } from "react";
import { Button } from "semantic-ui-react";
import { LookupsContext } from "../../lookups/LookupFactory";
import "./ProgressReporting.scss";
import ReceivingWaters from "../../models/ReceivingWaters";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";

export const ProgressReporting = () => {
    var { wmgIdParam } = useParams();

    const wmgId = useMemo(() => Number(wmgIdParam), [wmgIdParam]);
    const [lookups] = useContext(LookupsContext);

    const location = useLocation();
    const activeView = location.pathname.endsWith("downloads") ? "downloads" : "dashboard";

    const navigate = useNavigate();

    const setActiveView = useCallback((path: string) => {
        // TODO: Make sure this keeps history
        navigate(path);
    }, [navigate]);

    const receivingWaters: ReceivingWaters[] = useMemo(() => {
        return lookups.lutReceivingWaters
            .filter(rw => rw.wsGroupRWaterJurisdictionMapping
                .some(mapping => mapping.watershedManagementGroupId === wmgId));
    }, [lookups.lutReceivingWaters, wmgId])

    const jurisdictions = useMemo(() => lookups.jurisdictionGroups.filter(x => x.watershedManagementGroupId === wmgId)
        , [lookups.jurisdictionGroups, wmgId]);

    useEffect(() => {
        setTimeout(() => {
            document.getElementById('progress-section')?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    }, []);

    return (
        <>
            <div id="progress-section"></div>
            <div className="progress-reporting">
                <div className="top-section">
                    <div className="top-section-title">
                        {lookups ? lookups.getWatershedManagementGroupById(wmgId) : ""}
                    </div>
                    <div className="top-section-line"></div>
                    <div className="top-section-subtitle">
                        This page is dedicated to the {lookups ? lookups.getWatershedManagementGroupById(wmgId) : " "}
                        &nbsp;Watershed Management Group and provides information on water quality improvement progress and resulting co-benefits.
                    </div>
                    <div className="city-watershed-wrapper">
                        <div className="cities">
                            <div className="cities-title">
                                Permittees participating in this group are:
                            </div>
                            <div className="cities-text">
                                {jurisdictions.map((item, index) => {
                                    return (
                                        <div className="with-comma" key={item.id}>{lookups.getJurisdictionById(item.jurisdictionId)}{index < (jurisdictions.length - 1) ? ", " : ""}&nbsp;</div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="managed">
                            <div className="managed-title">
                                Subwatersheds managed by this group are:
                            </div>
                            <div className="managed-text">
                                {receivingWaters.map((rw, index) => {
                                    return (
                                        <div className="with-comma" key={index}>{rw.displayName}{index < (receivingWaters.length - 1) ? ", " : ""}&nbsp;</div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="button-group-section">
                    <Button.Group>
                        { /* TODO: Make sure this only shows up for ones with public reports */}
                        <Button
                            className={activeView === "downloads" ? "active no-wrap" : "no-wrap"}
                            onClick={() => setActiveView("downloads")}
                        >
                            Downloads
                        </Button>
                        { /* TODO: Make sure this only shows up for ones with public dashbaord */}
                        <Button
                            className={activeView === "dashboard" ? "active no-wrap" : "no-wrap"}
                            onClick={() => setActiveView("dashboard")}
                        >
                            Dashboard
                        </Button>
                    </Button.Group>
                </div>
                <div className="downloads-dashboard-wrapper">
                    <Outlet />
                </div>
            </div>
        </>
    )
}
